'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = config;
exports.getConfig = getConfig;
exports.setConfig = setConfig;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_CONFIG = 'redux-example/SET_CONFIG';

var initialState = {
  config: {}
};

function config() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_CONFIG:
      var newConfig = action.config;
      return (0, _extends3.default)({}, newConfig);
    default:
      return state;
  }
}

function getConfig(globalState) {
  return globalState.config ? globalState.config : null;
}

function setConfig(currentConfig) {
  return {
    type: SET_CONFIG,
    config: currentConfig
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/config.js
// module id = 1199
// module chunks = 0